// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"jr-z","breadcrumbForward":"kr-z","breadcrumbBack":"lr-z","selected":"mr-z"};